import React from "react";
import { Radar } from "react-chartjs-2";
import SectionCard from "../shared/SectionCard";
import "../shared/chartSetup";

const DEFAULT_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    r: {
      grid: { color: "#E4E7EC" },
      angleLines: { color: "#E4E7EC" },
      ticks: { display: false, stepSize: 20 },
      suggestedMin: 0,
      suggestedMax: 100,
      pointLabels: {
        font: { size: 11, weight: "500" },
        color: "#667085",
      },
    },
  },
};

/**
 * Traffic Sources radar/spider chart — multiple datasets, one per traffic type.
 *
 * @param {string}  [title="Traffic sources"]
 * @param {object}  chartData          Chart.js radar data object (supports multiple datasets)
 * @param {object}  [chartOptions]     Overrides default radar options
 * @param {number}  [chartHeight=220]  Height of the chart area in px
 */
const TrafficSourcesChart = ({
  title = "Traffic sources",
  chartData,
  chartOptions,
  chartHeight = 220,
}) => (
  <SectionCard title={title}>
    <div style={{ height: chartHeight }}>
      <Radar
        data={chartData ?? { labels: [], datasets: [] }}
        options={chartOptions ?? DEFAULT_OPTIONS}
      />
    </div>
  </SectionCard>
);

export default TrafficSourcesChart;
